/* ==========================================================================
   PARROTTY — Tab bar cart: live update + "added" pulse + mobile toast
   Updates, on every add-to-cart:
   - the tab bar cart badge count (via a fresh /cart.js fetch)
   - a brief scale-pulse animation on the tab bar cart icon
   - (mobile only, <750px) a bottom toast showing the added item's name,
     image, and price, auto-dismissing after 3 seconds, replacing Dawn's
     native top popup (hidden via CSS on mobile — see nura-mobile-toast.css)

   NURA FIX — the toast previously guessed "the item that was just added"
   from cart.items array position, which is unreliable: this store's cart
   PREPENDS genuinely new line items to the front, but adding a product
   that's ALREADY in the cart just bumps that existing line's quantity
   IN PLACE (its position doesn't move) — so "first/last index" is not a
   consistent signal for "most recently interacted with."
   Fixed by intercepting the /cart/add.js fetch response directly: Shopify
   returns the exact added/updated line item in that response body, so
   the toast now always reflects the real item, regardless of cart order.
   ========================================================================== */

(function () {
  var TOAST_DURATION = 3000;
  var toastTimer = null;

  function getWrap() {
    return document.querySelector('#nura-tabbar-cart .nura-tabbar__icon-wrap');
  }

  function formatMoney(cents) {
    return 'LE ' + (cents / 100).toFixed(2);
  }

  function updateBadgeAndPulse(count) {
    var wrap = getWrap();
    if (!wrap) return;

    var badge = wrap.querySelector('.nura-tabbar__badge');

    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'nura-tabbar__badge';
        wrap.appendChild(badge);
      }
      badge.textContent = count < 100 ? count : '';
    } else if (badge) {
      badge.remove();
    }

    wrap.classList.remove('nura-tabbar__icon-wrap--pulse');
    void wrap.offsetWidth;
    wrap.classList.add('nura-tabbar__icon-wrap--pulse');
  }

  function showMobileToast(item) {
    if (window.matchMedia && !window.matchMedia('(max-width: 749px)').matches) return;
    var toast = document.getElementById('nura-mobile-toast');
    if (!toast || !item) return;

    var img = toast.querySelector('.nura-mobile-toast__image');
    var price = toast.querySelector('.nura-mobile-toast__price');
    var name = toast.querySelector('.nura-mobile-toast__name');

    /* Inject the name element once, right before the price, if the
       static markup in nura-footer.liquid doesn't already have one. */
    if (!name) {
      name = document.createElement('p');
      name.className = 'nura-mobile-toast__name';
      if (price && price.parentNode) {
        price.parentNode.insertBefore(name, price);
      } else if (toast.querySelector('.nura-mobile-toast__content')) {
        toast.querySelector('.nura-mobile-toast__content').prepend(name);
      }
    }

    var imageUrl = item.image || (item.featured_image && item.featured_image.url) || '';

    if (img) {
      img.src = imageUrl;
      img.alt = item.product_title || item.title || '';
    }
    if (name) {
      name.textContent = item.product_title || item.title || '';
    }
    if (price) {
      var qty = item.quantity || 1;
      var unitPrice = formatMoney(item.price);
      price.textContent = qty > 1 ? (qty + ' \u00D7 ' + unitPrice) : unitPrice;
    }

    toast.classList.add('nura-mobile-toast--visible');

    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('nura-mobile-toast--visible');
    }, TOAST_DURATION);
  }

  function refreshBadgeCount() {
    fetch('/cart.js?_=' + Date.now(), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateBadgeAndPulse(cart.item_count);
      })
      .catch(function () {});
  }

  /* NURA — tapping/clicking the toast itself goes to the cart page, using
     the tab bar's own cart link href so it stays locale-correct (e.g.
     /ar/cart) rather than hardcoding "/cart". Wired once; the toast
     element is static markup in nura-footer.liquid, always present. */
  function initToastClickToCart() {
    var toast = document.getElementById('nura-mobile-toast');
    if (!toast || toast.dataset.nuraClickWired) return;
    toast.dataset.nuraClickWired = 'true';

    toast.setAttribute('role', 'button');
    toast.setAttribute('tabindex', '0');
    toast.setAttribute('aria-label', 'View cart');
    toast.style.cursor = 'pointer';

    function goToCart() {
      var tabbarCartLink = document.getElementById('nura-tabbar-cart');
      var href = (tabbarCartLink && tabbarCartLink.getAttribute('href')) || '/cart';
      window.location.href = href;
    }

    toast.addEventListener('click', goToCart);
    toast.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        goToCart();
      }
    });
  }

  /* Intercept the /cart/add(.js|.json) fetch Dawn's product-form.js
     issues, and read the added item straight from its response — this
     is the authoritative source, not a guess based on cart order. */
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCartAdd = url.indexOf('/cart/add') !== -1;

    return originalFetch.apply(this, arguments).then(function (response) {
      if (isCartAdd && response.ok) {
        response
          .clone()
          .json()
          .then(function (data) {
            /* A bundle/multi-add request returns { items: [...] }; a
               single-variant add returns the item object directly. */
            var addedItem = data && data.items && data.items.length ? data.items[data.items.length - 1] : data;
            if (addedItem && (addedItem.product_title || addedItem.title)) {
              showMobileToast(addedItem);
            }
            refreshBadgeCount();
          })
          .catch(function () {
            refreshBadgeCount();
          });
      }
      return response;
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    refreshBadgeCount();
    initToastClickToCart();
  });
})();
